<template>
  <div>
    <vue-good-table
        :columns="columns"
        :rows="onBoardingPendingRequests"
        class="table-word-wrap"
        :pagination-options="{enabled: this.paginationEnabled, ...paginationOptions}"
    >
      <template slot="table-column" slot-scope="props">
                <span v-if="props.column.label === 'Supplier setup status'">
                  <header-with-tooltip :tooltipText="apexStatusTooltip"> {{props.column.label}} </header-with-tooltip>
                </span>
        <span v-else>{{props.column.label}}</span>
      </template>
      <template slot="table-row" slot-scope="props">
                            <span v-if="props.column.field === 'caseNumber'">
                              <span class="solution-link" @click="$emit('onViewCaseDetails', props.row.caseNumber)"> {{ props.row.caseNumber }} </span>
                            </span>
                            <span v-else-if="props.column.field === 'supplierApexStatus'">
                              <span v-if="!ifApexStatusInValid(props.row.supplierApexStatus)">
                                {{getSupplierSetupStatusIfApexBlank(props.row.caseNumber)}}
                              </span>
                              <span v-else>{{props.row.supplierApexStatus}}</span>
                            </span>
                            <span v-else-if="props.column.field === 'actions'">
                                <div class="content row-content">
                                  <span class="solution-link" @click="$emit('onViewCaseDetails', props.row.caseNumber)"> View </span> |
                                  <span class="solution-link" @click="closeCase(props.row)"> Close </span> |
                                  <span class="solution-link" @click="duplicateCaseRedirect(props.row.id)"> Duplicate </span>
                                </div>
                            </span>
      </template>
    </vue-good-table>
  </div>
</template>

<script>
import { VueGoodTable } from "vue-good-table";
import { mapGetters, mapMutations } from "vuex";
import CloseRITMModal from "@/components/CloseRITMModal";
import swal from "sweetalert2";
import VGT_PAGINATION_OPTIONS from "../store/vgtPaginationOptions";
import EXCEPTION_SUBMISSION_CONSTANTS from "@/store/exceptionSubmissionRequestFormConstants";
import SupplierOnboardStatusTrackerMixin from "@/mixins/SupplierOnboardStatusTrackerMixin";
import HeaderWithTooltip from "@/components/HeaderWithTooltip.vue";

export default {
  name: "RecentlySubmittedRITMList",
  mixins: [SupplierOnboardStatusTrackerMixin],
  components: {HeaderWithTooltip, VueGoodTable },
  methods: {
    ...mapMutations(["setErrorMessage","setRitmStatusAccessPoint"]),
    closeCase(ritm) {
      document.documentElement.style.overflow = "hidden";
      this.$modal.show(
          CloseRITMModal,
          {
            record: ritm
          },
          {
            name: "CloseRITMModal",
            adaptive: true,
            height: "auto",
            width: "730",
          },
          {
            onClosed: (success) => {
              document.documentElement.style.overflow = "auto";
              this.$modal.hide('CloseRITMModal')
              if(success) {
                this.$hhMixpanel.trackEvent("Vendor One-Intake user closed a submitted case", {CaseNumber : ritm.caseNumber});
                this.showSuccessMessage(ritm)
              }
            },
            closed: () => {
              document.documentElement.style.overflow = "auto";
            }
          }
      );
    },
    showSuccessMessage(ritm) {
      let caseNumber = ritm.caseNumber
      swal
          .fire({
            title: `Case closed`,
            html: `${caseNumber} case was closed`,
            showCancelButton: false,
            confirmButtonText: "Close",
            focusConfirm: false,
            allowOutsideClick: false,
            allowEscapeKey: false,
            customClass: {
              confirmButton: "flat-btn primary-blue-btn btn mb-3",
            },
            buttonsStyling: false,
          })
          .then((result) => {
            if (result.isConfirmed) {
              this.$emit('onCaseClosed')
            }
          })
    },
    duplicateCaseRedirect(id){
      this.$hhMixpanel.trackEvent("Duplicate case request")
      this.$router.push({name: "DuplicateIntakeForm", params: { id, isCompletedCase: false }})
    },
  },
  data() {
    return {
      paginationOptions:VGT_PAGINATION_OPTIONS.RECENTLY_SUBMITTED_RITM_LIST_PAGINATION_OPTIONS
    }
  },
  computed: {
    ...mapGetters(["onBoardingPendingRequests"]),
    paginationEnabled() {
      return this.onBoardingPendingRequests.length > 5
    },
    columns() {
      return [
        {
          label: "Case",
          field: "caseNumber",
          type: "string",
          thClass: "width-sm",
          tdClass: "align-left",
          width: "15%"
        },
        {
          label: "Request type",
          field(rowObj) {
            if(rowObj.requestSubmissionType === EXCEPTION_SUBMISSION_CONSTANTS.EXIT_POINT)
              return "Exception submission"
            return "Supplier engagement"
          },
          type: "string",
          thClass: "width-sm",
          tdClass: "align-left",
          width: "25%"
        },
        {
          label: "Case status",
          field: "status",
          type: "string",
          thClass: "width-sm hide-field-xs",
          tdClass: "align-left hide-field-xs",
          width: "20%"
        },
        {
          label: "Product description",
          field: "productDescription",
          type: "string",
          thClass: "width-sm hide-field-xs",
          tdClass: "align-left hide-field-xs word-wrap",
          width: "24%"
        },
        {
          label: "Supplier setup status",
          field: "supplierApexStatus",
          type: "string",
          thClass: "width-sm hide-field-xs",
          tdClass: "align-left hide-field-xs word-wrap",
          width: "18%",
          sortable: false
        },
        {
          label: "Date added",
          type: "string",
          field(rowObj) {
            if(rowObj.createdOn){
              return rowObj.createdOn.substring(0,10)
            }
          },
          thClass: "width-sm hide-field-xs",
          tdClass: "hide-date-responsive hide-field-xs",
          width: "15%"
        },
        {
          label: "Actions",
          field: "actions",
          thClass: "th-actions text-nowrap",
          tdClass: "td-actions text-nowrap",
          width: "22%",
          sortable: false
        }
      ];
    }
  }
}


</script>

<style scoped src="@/assets/stylesheets/vgtStyles.css">
</style>